import * as types from './types';
import createReducer from '../../createReducer';
import { FETCH_STATE } from 'constants';

const initialState = {
  invoice: null,
  loading: false,
  fetchingInvoice: FETCH_STATE.UNSENT,
  asyncErrors: {},
  fetchingInvoiceItem: false,
  invoices: [],
  fetchingInvoices: false,
  sources: [],
  fetchingSources: false,
  pagination: {},
  fetchingSendEmailInvoice: false,
  sendEmailInvoiceSuccess: false,
  fetchingExportInvoice: false,
  exportInvoiceSuccess: false,
  fetchedProcessInvoice: false,
  fetchedPublishInvoice: false,
  fetchedCreateInvoice: false,
  current: {},
  fetchingProcessingRefunds: FETCH_STATE.UNSENT,
  wizard: {
    current: {},
    exitWizard: false,
    currentGroup: '',
    exitStep: false,
    lastStep: false,
    position: 0,
    errors: {},
    steps: {},
  },
  accountEmitter: {},
  fetchAccountEmitter: FETCH_STATE.UNSENT,
  fetchInvoiceApprovalUpdate: FETCH_STATE.UNSENT,
};

const invoiceReducer = createReducer(initialState)({
  [types.FETCH_PROCESS_INVOICES_BY_IDS_REQUEST]: (state) => ({
    ...state,
    fetchingProcessingRefunds: FETCH_STATE.LOADING,
  }),
  [types.FETCH_PROCESS_INVOICES_BY_IDS_SUCCESS]: (state) => ({
    ...state,
    fetchingProcessingRefunds: FETCH_STATE.DONE,
  }),
  [types.FETCH_PROCESS_INVOICES_BY_IDS_FAILED]: (state) => ({
    ...state,
    fetchingProcessingRefunds: FETCH_STATE.ERROR,
  }),
  [types.FETCH_INVOICES_REQUEST]: (state) => {
    return {
      ...state,
      fetchingInvoices: FETCH_STATE.LOADING,
      fetchingProcessingRefunds: FETCH_STATE.UNSENT,
    };
  },
  [types.FETCH_INVOICES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingInvoices: FETCH_STATE.DONE,
      invoices: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_INVOICES_FAILED]: (state) => {
    return {
      ...state,
      fetchingInvoices: FETCH_STATE.ERROR,
    };
  },

  [types.FETCH_INVOICE_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchingInvoice: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_INVOICE_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      fetchingInvoice: FETCH_STATE.DONE,
      invoice: payload,
      current: {
        ...state.current,
        [payload.id]: payload,
      },
    };
  },
  [types.FETCH_INVOICE_BY_ID_RESET]: (state) => {
    return {
      ...state,
      current: {},
    };
  },
  [types.FETCH_INVOICE_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      invoice: null,
      loading: false,
      fetchingInvoice: FETCH_STATE.ERROR,
    };
  },
  [types.FETCH_ACCOUNT_EMITTER_REQUEST]: (state) => {
    return {
      ...state,
      accountEmitter: {},
      fetchAccountEmitter: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_ACCOUNT_EMITTER_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      accountEmitter: payload,
      fetchAccountEmitter: FETCH_STATE.DONE,
    };
  },
  [types.FETCH_ACCOUNT_EMITTER_FAILED]: (state) => {
    return {
      ...state,
      fetchAccountEmitter: FETCH_STATE.ERROR,
    };
  },

  [types.FETCH_PROCESS_INVOICE_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedProcessInvoice: false,
    };
  },
  [types.FETCH_PROCESS_INVOICE_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      invoice: payload,
      fetchedProcessInvoice: true,
    };
  },
  [types.FETCH_PROCESS_INVOICE_BY_ID_FAILED]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
    };
  },

  [types.FETCH_ADD_ITEM_TO_INVOICE_REQUEST]: (state) => {
    return {
      ...state,
      fetchingInvoiceItem: true,
      fetchedProcessInvoice: false,
    };
  },
  [types.FETCH_ADD_ITEM_TO_INVOICE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingInvoiceItem: false,
      invoice: payload,
      fetchedProcessInvoice: true,
    };
  },
  [types.FETCH_ADD_ITEM_TO_INVOICE_FAILED]: (state) => {
    return {
      ...state,
      fetchingInvoiceItem: false,
    };
  },

  [types.FETCH_UPDATE_INVOICE_ITEM_REQUEST]: (state) => {
    return {
      ...state,
      fetchingInvoiceItem: true,
      fetchedProcessInvoice: false,
    };
  },
  [types.FETCH_UPDATE_INVOICE_ITEM_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingInvoiceItem: false,
      invoice: payload,
      fetchedProcessInvoice: true,
    };
  },
  [types.FETCH_UPDATE_INVOICE_ITEM_FAILED]: (state) => {
    return {
      ...state,
      invoice: null,
      fetchingInvoiceItem: false,
    };
  },

  [types.FETCH_DELETE_ITEM_FROM_INVOICE_REQUEST]: (state) => {
    return {
      ...state,
      fetchingInvoiceItem: true,
    };
  },
  [types.FETCH_DELETE_ITEM_FROM_INVOICE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      invoice: payload,
      fetchingInvoiceItem: false,
    };
  },
  [types.FETCH_DELETE_ITEM_FROM_INVOICE_FAILED]: (state) => {
    return {
      ...state,
      fetchingInvoiceItem: false,
    };
  },

  [types.FETCH_INVOICE_SOURCES_REQUEST]: (state) => {
    return {
      ...state,
      fetchingSources: true,
    };
  },
  [types.FETCH_INVOICE_SOURCES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      sources: payload,
      fetchingSources: false,
    };
  },
  [types.FETCH_INVOICE_SOURCES_FAILED]: (state) => {
    return {
      ...state,
      sources: [],
      fetchingSources: false,
    };
  },
  // export invoice
  [types.FETCH_EXPORT_INVOICE_REQUEST]: (state) => {
    return {
      ...state,
      fetchingExportInvoice: true,
      exportInvoiceSuccess: false,
    };
  },
  [types.FETCH_EXPORT_INVOICE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingExportInvoice: false,
      exportInvoiceSuccess: true,
    };
  },
  [types.FETCH_EXPORT_INVOICE_FAILED]: (state) => {
    return {
      ...state,
      fetchingExportInvoice: false,
      exportInvoiceSuccess: false,
    };
  },

  // export invoice
  [types.FETCH_SEND_EMAIL_INVOICE_REQUEST]: (state) => {
    return {
      ...state,
      fetchingSendEmailInvoice: true,
      exportInvoiceSuccess: false,
    };
  },
  [types.FETCH_SEND_EMAIL_INVOICE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingSendEmailInvoice: false,
      sendEmailInvoiceSuccess: true,
    };
  },
  [types.FETCH_SEND_EMAIL_INVOICE_FAILED]: (state) => {
    return {
      ...state,
      fetchingSendEmailInvoice: false,
      sendEmailInvoiceSuccess: false,
    };
  },
  [types.FETCH_REFUND_REQUEST]: (state) => {
    return {
      ...state,
      fetchingRefund: true,
      fetchedRefund: false,
    };
  },
  [types.FETCH_REFUND_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedRefund: true,
      fetchingRefund: false,
    };
  },
  [types.FETCH_REFUND_FAILED]: (state) => {
    return {
      ...state,
      fetchedRefund: false,
      fetchingRefund: false,
    };
  },

  [types.RESET_REFUND_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedRefund: false,
      fetchingRefund: false,
    };
  },
  // WIZARD CHANGE POSITION
  [types.CHANGE_POSITION]: (state, { payload }) => {
    return {
      ...state,
      wizard: {
        ...state.wizard,
        position: payload.position,
      },
    };
  },
  // RESET WIZARD
  [types.RESET_WIZARD]: (state) => {
    return {
      ...state,
      invoice: null,
      wizard: {
        exitOnboarding: false,
        exitStep: false,
        lastStep: false,
        position: 0,
        errors: {},
        steps: {},
      },
    };
  },

  [types.SET_EXIT]: (state, { payload }) => {
    return {
      ...state,
      wizard: {
        ...state.wizard,
        [payload.type]: payload.exit,
      },
    };
  },

  [types.FETCH_CREATE_INVOICE_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedCreateInvoice: false,
    };
  },
  [types.FETCH_CREATE_INVOICE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      invoice: payload,
      fetchedCreateInvoice: true,
    };
  },
  [types.FETCH_CREATE_INVOICE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      wizard: {
        ...state.wizard,
        errors,
      },
      loading: false,
      fetchedCreateInvoice: false,
    };
  },

  [types.FETCH_UPDATE_INVOICE_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedCreateInvoice: false,
    };
  },
  [types.FETCH_UPDATE_INVOICE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      invoice: payload,
      current: {
        ...state.current,
        [payload.id]: payload,
      },
      fetchedCreateInvoice: true,
    };
  },
  [types.FETCH_UPDATE_INVOICE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      wizard: {
        ...state.wizard,
        errors,
      },
      loading: false,
      fetchedCreateInvoice: false,
    };
  },

  [types.FETCH_PUBLISH_INVOICE_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedPublishInvoice: false,
    };
  },
  [types.FETCH_PUBLISH_INVOICE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      invoice: { ...state.invoice, ...payload },
      current: {
        ...state.current,
        [payload.id]: { ...state?.current[payload.id], ...payload },
      },
      fetchedPublishInvoice: true,
    };
  },
  [types.FETCH_PUBLISH_INVOICE_FAILED]: (state, { errors }) => {
    return {
      ...state,
      loading: false,
      fetchedPublishInvoice: false,
    };
  },
  [types.FETCH_UPDATE_INVOICE_APPROVAL_REQUEST]: (state, { errors }) => {
    return {
      ...state,
      fetchInvoiceApprovalUpdate: FETCH_STATE.LOADING,
    };
  },
  [types.FETCH_UPDATE_INVOICE_APPROVAL_SUCCESS]: (state, { errors }) => {
    return {
      ...state,
      fetchInvoiceApprovalUpdate: FETCH_STATE.DONE,
      fetchingInvoice: FETCH_STATE.UNSENT,
    };
  },
  [types.FETCH_UPDATE_INVOICE_APPROVAL_FAILED]: (state, { errors }) => {
    return {
      ...state,
      fetchInvoiceApprovalUpdate: FETCH_STATE.FAILED,
    };
  },
});

export default invoiceReducer;
